import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import commonStyles from "../../styles/Common.module.css";
import inputStyles from "../Courses/styles/CreateCourse.module.css";
import styles from "../Courses/styles/EnrollUser.module.css";
import tableStyles from "../Users/styles/Users.module.css";
import { getUserFun } from "../../Redux/Users/action";
import { useParams } from "react-router-dom";
import { Autocomplete, Box, Modal, TextField } from "@mui/material";
import modalStyles from "../../styles/ModalStyle.module.css";
import { setPrimeListFun } from "../../Redux/Prime/action";

const CreateOrder = () => {
    const dispatch = useDispatch();
    const { users } = useSelector((store) => store.users);
    const { prime_research_list } = useSelector((store) => store.prime);
    const [checkData, setCheckData] = useState({
        email: "",
        phone_number: "",
        first_name: "",
        last_name: "",
    });

    const [modalData, setModalData] = useState({
        product_Id: "",
        user_Id: "",
        amount: "",
    })
    const [modalOpen, setModalOpen] = useState(false);

    useEffect(() => {
        dispatch(setPrimeListFun());

        return () => {
            
        };
    }, []);

    const articleList = prime_research_list?.map((ele) => {
        return { label: ele.company_Id.company_name, id: ele._id };
    });

    const handleChange = (ele) => {
        const { id, value } = ele.target;

        setCheckData({
            ...checkData,
            [id]: value
        });
    };

    const handleSubmit = (event) => {
        event.preventDefault();

        dispatch(getUserFun({ email: checkData.email, phone_number: checkData.phone_number, first_name: checkData.first_name, last_name: checkData.last_name }));
    }

    const handleCreateOrder = async (event) => {
        event.preventDefault();
        setModalOpen(false)

        const res = await fetch("https://api.sovrenn.com/manual/prime-order", {
            method: "POST",
            headers: {
                "Content-type": "application/json",
                "Authorization": "Bearer " + localStorage.getItem("sov_user")
            },
            body: JSON.stringify(modalData)
        });

        const data = await res.json();

        if (res.ok) {
            if(data.success === false) {
                alert(data.message);
                return;
            };
            
            alert("Created Order Successfully!");

            dispatch(getUserFun({ email: checkData.email, phone_number: checkData.phone_number, first_name: checkData.first_name, last_name: checkData.last_name }));

            return;
        };

        alert("Something went wrong while creating the order.");
        return;
    }

    return (
        <div className={`${commonStyles.MainContainer} ${inputStyles.CreateMainContainer}`}>
            <div className={commonStyles.headerDiv}>
                <h1>Create Order</h1>
            </div>

            <div id={inputStyles.formDiv}>
                <form action="" id={inputStyles.form} onSubmit={handleSubmit}>


                    <div id={inputStyles.secondChildDiv}>
                        <div className={inputStyles.inputDiv}>
                            <label htmlFor="email">
                                Email
                            </label>
                            <input type="email" id="email" name="email" onChange={handleChange} />
                        </div>
                        <div className={inputStyles.inputDiv}>
                            <label htmlFor="phone_number">
                                Phone Number
                            </label>
                            <input type="number" id="phone_number" name="phone_number" onChange={handleChange} />
                        </div>
                    </div>

                    <div id={inputStyles.secondChildDiv}>
                        <div className={inputStyles.inputDiv}>
                            <label htmlFor="first_name">
                                First Name
                            </label>
                            <input type="text" id="first_name" name="first_name" onChange={handleChange} />
                        </div>
                        <div className={inputStyles.inputDiv}>
                            <label htmlFor="last_name">
                                Last Name
                            </label>
                            <input type="text" id="last_name" name="last_name" onChange={handleChange} />
                        </div>
                    </div>

                    <button type="submit" style={{ marginTop: "0" }}>Find User</button>
                </form>
            </div>

            <hr />

            <table id={tableStyles.userListContainer}>
                <thead id={tableStyles.userListHead}>
                    <tr className={tableStyles.userCard}>
                        <th>Name</th>
                        <th>Email</th>
                        <th>Country</th>
                        <th>Phone Number</th>
                        <th>State</th>
                        <th>Select</th>
                    </tr>
                </thead>

                <tbody>
                    {users.map((ele, ind) => {
                        return <tr className={tableStyles.userCard} key={ele._id}>
                            <td >
                                {ele.first_name} {ele.last_name}
                            </td>
                            <td>{ele.email}</td>
                            <td>{ele.country_code}</td>
                            <td>{ele.phone_number}</td>
                            <td>{ele.state}</td>
                            <td>{ele.subscriptions.includes("full-access") ? <button disabled>Full Access</button> : <button onClick={() => {
                                setModalData({
                                    ...modalData,
                                    user_Id: ele._id
                                });
                                setModalOpen(true);
                            }}>Select</button>}</td>
                        </tr>
                    })}
                </tbody>
            </table>


            <Modal open={modalOpen} onClose={() => setModalOpen(false)}>
                <Box className={modalStyles.InfoModal}>

                    <h3>Select Article & Amount</h3>
                    <form onSubmit={handleCreateOrder} className={modalStyles.modalForm}>

                        <Autocomplete
                            sx={{marginTop: "20px"}}
                            fullWidth
                            size="medium"
                            disablePortal
                            id="company_Id"
                            name="company_Id"
                            options={articleList}
                            onChange={(ele, value) => {
                                setModalData({
                                    ...modalData,
                                    product_Id: value.id
                                });
                            }}
                            getOptionSelected={(option, value) => option.value === value.value}
                            renderInput={(params) => <TextField required {...params} label="Select Aticle" />}
                        />

                        <input type="number" placeholder="Select Amount" className={modalStyles.selectAmt} onChange={(ele) => {
                            setModalData({
                                ...modalData,
                                amount: ele.target.value
                            });
                        }} />
                        <button className={modalStyles.submitBtn}>Create</button>
                    </form>
                </Box>
            </Modal>
        </div>
    )
}

export default CreateOrder